let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hz1Bn")).then(() => parcelRequire('4584f'));